import { FolderClosed } from 'almanac-ui/icons'
import { ReactComponent as LockedIcon } from 'assets/icons/lockedFolder.svg'

export const FolderIcon = ({ className }: { className?: string }) => {
  return <FolderClosed className={className} />
}

export const LockedFolderIcon = ({ className }: { className?: string }) => {
  return <LockedIcon className={className} />
}
